<template>
  <div class="file-list">
    <div v-if="skjolSpinner" class="loading">Loading files...</div>

    <v-data-table
     :headers="headers"
      :items="joakim.skjol"
      class="m-b-128"
      :loading="joakim.skjolSpinner"
      loading-text="Sæki skjöl..."
      no-data-text="Engin skjöl fundust"
      hover
      :footer-props="{
        itemsPerPageText: 'Færslur á síðu',
        itemsPerPageAllText: 'Sjá allt',
        showFirstLastPage: true
      }"
    >
      <!-- Date formatting slot -->
      <template #item.dags="{ item }">
        {{ formatDate(item.dags) }}
      </template>

      <!-- Download button slot -->
      <template #item.actions="{ item }">
        <CustomButton
          :title="t('Files_download')"
          :loading="downloading"
          @click="downloadSkjal(item.skjalID)"
        >
          {{ t('Files_download') }}
        </CustomButton>
      </template>
    </v-data-table>
  </div>
</template>

<script setup lang="ts">
import { watch, ref } from 'vue'
import type { DataTableHeader } from 'vuetify';
import { useJoakimStore } from '@/stores/useJoakimStore'
import { useI18n } from 'vue-i18n'
const { skjol, skjolSpinner, getSkjol } = useJoakimStore()
const { t } = useI18n()
const downloading = ref(false)
import CustomButton from '../customButton/CustomButton.vue';
import { useAuthStore } from '@/stores/useAuthStore';

const joakim = useJoakimStore();

const auth = useAuthStore();

const headers: DataTableHeader[] = [
  { title: t('skjolTable_lysing'), key: 'lysing' },
  { title: t('skjolTable_dags'), key: 'dags' },
  { title: '', key: 'actions', align: 'end', sortable: false },
];

watch(
  () => auth.authUser,
  (user) => {
    if (user && !skjol.length) {
      getSkjol();
    }
  },
  { immediate: true }

  
);

const downloadSkjal = async (skjalId: string) => {
  downloading.value = true
  try {
    await joakim.downloadSkjal(skjalId)
  } finally {
    downloading.value = false
  }
}

const formatDate = (isoDate: string | null) => {
  if (!isoDate) return '';
  return new Date(isoDate).toLocaleDateString('is-IS', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};


</script>

<style scoped>
.file-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.loading {
  font-style: italic;
  color: gray;
}

.file-list-items {
  list-style: none;
  padding: 0;
  margin: 0;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 0.5rem 0;
}

.file-info {
  display: flex;
  flex-direction: column;
}

.file-name {
  font-weight: bold;
}

.file-date {
  font-size: 0.875rem;
  color: #666;
}
</style>